import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, omit } from 'lodash-es';
import { withRouter } from 'react-router-dom';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import {
  buildVehiclePath as buildGraphqlVehiclePath,
  VehicleGraphqlEntities,
  VehicleGraphQLModel,
} from 'client/data/models/vehicle-graphql';
import {
  VehicleModel,
  VehicleEntities,
  buildVehiclePath,
  buildDefaultVehiclePath,
} from 'client/data/models/vehicle-v2';
import { updateVehicle, buildContextVehicleFromMakeModelSubmodelYear } from 'client/actions/vehicle';
import { isUsed as isUsedPubState } from 'site-modules/shared/utils/publication-states';
import { pageDefinition } from 'site-modules/shared/pages/page';

const mapDispatchToProps = dispatch => ({
  /**
   * @param makeModelSubmodelYear
   */
  updateVehicle: makeModelSubmodelYear => {
    const isUsed = isUsedPubState(get(makeModelSubmodelYear, 'pubStates', {}));
    const vehicleForContext = buildContextVehicleFromMakeModelSubmodelYear(makeModelSubmodelYear, { isUsed });
    dispatch(updateVehicle(vehicleForContext));
  },
});

export function corePageDecorator(options, params) {
  const { component } = options;
  const useGraphqlVehicle = options?.options?.useGraphqlVehicle;

  class CorePageComponentUI extends Component {
    constructor(props) {
      super(props);
      const vehicle = props.vehicle || props.vehicleGraphql;

      this.props.updateVehicle(vehicle);

      this.newParams = !params.year ? { ...params, year: vehicle?.year } : params;
    }

    render() {
      return createElement(component, {
        ...omit(this.props, ['vehicle', 'vehicleGraphql']),
        vehicle: this.props.vehicle || this.props.vehicleGraphql,
        params: this.newParams,
      });
    }
  }

  CorePageComponentUI.propTypes = {
    ...component.propTypes,
    vehicle: VehicleEntities.MakeModelSubmodelYear,
    vehicleGraphql: VehicleGraphqlEntities.Vehicle,
    updateVehicle: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  };

  CorePageComponentUI.defaultProps = {
    vehicle: null,
    vehicleGraphql: null,
  };

  const CorePageComponent = withRouter(
    connect(
      null,
      mapDispatchToProps
    )(
      connectToModel(CorePageComponentUI, {
        vehicle: bindToPath(
          () => !useGraphqlVehicle && (params.year ? buildVehiclePath(params) : buildDefaultVehiclePath(params)),
          VehicleModel
        ),
        vehicleGraphql: bindToPath(() => useGraphqlVehicle && buildGraphqlVehiclePath(params), VehicleGraphQLModel),
      })
    )
  );

  return pageDefinition({
    ...options,
    component: CorePageComponent,
  });
}
